import { Box } from '@mui/material';

import Page from '../../../../components/Page/index.ts';
import StaticPageLayout from '../../../../components/StaticPageLayout/index.ts';

export default function Terms() {
  return (
    <Page title="Sommerkampanje vilkår">
      <StaticPageLayout
        title="Vilkår for Scooprs Juli-kampanje 2024"
        breadcrumbsItems={[
          {
            text: 'Hjem',
            url: '/',
          },
          {
            text: 'Sommerkampanje 2024',
            url: '/sommer-trekning-forlengelse',
          },
          {
            text: 'Vilkår for Scooprs Juli-kampanje 2024',
            url: null,
          },
        ]}
        subtitle="Dato for siste versjon: 01.07.2024"
      >
        <Box
          sx={(theme) => ({
            '& h2': {
              marginBottom: theme.spacing(2),
              marginTop: theme.spacing(6),
            },
            '& h3': {
              marginBottom: theme.spacing(1),
              marginTop: theme.spacing(3),
            },
          })}
        >
          <h3>1 – Vilkår for Scooprs Juli-kampanje 2024</h3>
          <p>
            I juli og august 2024 avholder Scoopr Refinansiering AS og Scoopr AS («Scoopr») en
            trekning, der deltakere har mulighet til å vinne nedbetaling av rentebærende
            kredittkort- og/eller forbruksgjeld, kalt Juli-kampanjen. Disse vilkårene gjelder for
            deltakelse i Juli-kampanjen.
          </p>
          <h3>1.1 – Krav for deltakelse</h3>
          <p>
            Juli-kampanjen er tilgjengelig for personer over 18 år, som har tilgang til BankID/Vipps
            og som er bosatt i Norge. Deltakeren må ha rentebærende kredittkort- og/eller
            forbruksgjeld over 1.000 kroner.
          </p>
          <p>
            Deltakere melder seg på Juli-kampanjen ved å trykke «Sjekk din gjeld og delta»,
            godkjenne disse vilkårene, og gi samtykke til at Scoopr henter ut informasjon fra
            Gjeldsregisteret.
          </p>
          <p>
            Det koster ingenting å delta i Juli-kampanjen, men det er et krav om at deltakeren har
            en «Min Scoopr»- bruker. Vilkårene for Min Scoopr finnes{' '}
            <a href="https://scoopr.no/brukervilkar-min-scoopr" target="_blank" rel="noreferrer">
              her
            </a>
            . Deltakeren kan når som helst avslutte sin brukerkonto etter at Juli-kampanjen er
            avsluttet.
          </p>
          <p>
            Ansatte i Scoopr og deres ektefeller, samboere, foreldre, søsken eller barn kan ikke
            delta i Juli-kampanjen. Deltakere som ikke oppfyller kravene, kan bli nektet lodd
            og/eller premie.
          </p>
          <h3>1.2 – Om premien</h3>
          <p>Det trekkes 5 vinnere i Juli-kampanjen.</p>
          <p>
            Premien som utloddes til vinnerne i Juli-kampanjen tilsvarer Scooprs beregning* av
            deltakerens kostnad, de neste 12 mnd, tilknyttet betjening av deltakerens usikrede
            rentebærende kredittkort- og/eller forbruksgjeld på registreringstidspunktet. (*se punkt
            1.9 for beregning)
          </p>
          <p>Beløpet kan ikke overskride 80.000 per vinner.</p>
          <p>
            Beløpet betales direkte til banken hvor gjelden er registrert. Dersom det er registrert
            gjeld hos flere banker velger Scoopr hvilken bank gjelden innfris hos (produkter med
            høyeste rente blir prioritert først). Det er ikke anledning til å få beløpet utbetalt i
            kontanter, eller i form av andre ytelser.
          </p>
          <p>
            Dersom deltaker velger å refinansiere sin kredittkort- eller forbruksgjeld hos Scoopr
            innen trekningen, vil premien kunne benyttes til å nedbetale på̊ det nye lånet.
          </p>
          <h3>1.3 – Vilkår for mottak av premie</h3>
          <p>
            Vinneren kontaktes på telefon og e-post. Vinneren må straks etter å ha blitt kontaktet
            oppgi og bekrefte betalingsopplysninger slik at den aktuelle gjelden kan innfris. Dersom
            dette ikke er gjort innen 5 dager, vil retten til premie kunne bortfalle.
          </p>
          <p>
            Vinnere er selv ansvarlig for å rapportere og håndtere eventuell gevinst til
            skattemyndighetene, samt overholdelse av andre lovpålagte krav i forbindelse med
            gevinsten.
          </p>
          <h3>1.4 – Varighet og trekning</h3>
          <p>
            Juli-kampanjen varer fra 1. juli til 15. august 2024 («Trekningsperioden»), og det
            trekkes vinner den 16. august 2024. For å være med i trekningen må deltakeren melde seg
            på i perioden og senest innen midnatt den 15. august 2024. Deltakere fra
            “sommerkampanje” er automatisk med i trekningen dersom de fortsatt har en «Scoopr-
            bruker» registrert.
          </p>
          <p>
            Vinneren trekkes tilfeldig ved at alle deltakere får tildelt et deltakernummer.
            Trekningen gjøres gjennom en «random number generator service».
          </p>
          <h3>1.5 – Ansvarlig arrangør og tredjeparter</h3>
          <p>Det er Scoopr som er arrangør av Juli-kampanjen.</p>
          <p>
            Juli-kampanjen støttes eller sponses ikke av noen tredjepart. Det opplyses særskilt om
            at Juli-kampanjen verken støttes eller sponses av Meta, TikTok eller Google, selv om
            markedsføring skulle foregå gjennom disse kanalene. Deltakere kan ikke rette noen krav
            mot slike tredjeparter i forbindelse med konkurransen.
          </p>
          <h3>1.6 – Personopplysninger</h3>
          <p>
            I forbindelse med deltakelse vil Scoopr behandle personopplysninger. Personopplysningene
            benyttes til å registrere «Min Scoopr»-bruker, kontrollere overholdelse av vilkår og
            utnevne og kontakte vinnere.
          </p>
          <p>
            Scoopr behandler også opplysninger fra Gjeldsregisteret. Samtykket kan trekkes tilbake
            når som helst på{' '}
            <a href="https://www.gjeldsregisteret.com/" target="_blank" rel="noreferrer">
              www.gjeldsregisteret.com
            </a>
            .
          </p>
          <p>
            I løpet av Trekningsperioden kan Scoopr sende informasjon på e-post og SMS for å minne
            om Juli-kampanjen og gi informasjon om trekning og vinnere. Vinnere vil aldri bli
            annonsert med fullt navn, med mindre vinneren har samtykket til dette.
          </p>
          <p>
            Dersom deltakeren har takket ja til å motta markedsføring fra Scoopr, vil det også
            sendes markedsføring til vedkommende, også i etterkant av Trekningsperioden.
          </p>
          <p>
            Opplysningene om deltakere lagres i perioden Juli-kampanjen avholdes og i en viss
            periode etterpå for å kunne påvise at Scoopr har overholdt lovpålagte krav.
            Opplysningene registrert i Min Scoopr oppbevares frem til brukeren sletter sin profil.
          </p>
          <p>
            Opplysningene kan bli delt med andre selskaper i Scoopr-konsernet for formålene
            beskrevet over. Se mer informasjon i Scooprs personvernerklæring{' '}
            <a href="https://scoopr.no/personvernerklaering/" target="_blank" rel="noreferrer">
              her
            </a>
            .
          </p>
          <h3>1.7 – Avbryte</h3>
          <p>
            Dersom uforutsette hendelser skulle oppstå, som Scoopr ikke med rimelighet kunne forutse
            ved igangsetting av Juli-kampanjen, forbeholder Scoopr seg retten til å avbryte
            konkurransen med fremtidig virkning. Scoopr vil utlodde premier til vinnere som allerede
            er trukket og så langt mulig varsle deltakere og gi deltakere mulighet for
            avregistrering og avslutning av Min Scoopr-brukeren.
          </p>
          <h3>1.8 – Henvendelser</h3>
          <p>
            Dersom deltakeren har spørsmål om disse vilkårene eller andre forhold kan Scoopr
            Refinansiering AS, med adresse Karenslyst Allé 2, 0278 Oslo, kontaktes på telefon 488 46
            665 eller e-post: <a href="mailto:post@scoopr.no">post@scoopr.no</a>.
          </p>
          <h3>1.9 – Scooprs beregning av deltakernes kostnad de neste 12 mnd</h3>
          <p>Scooprs beregning er basert på data fra Gjeldsregisteret.</p>
          <p>
            Det beregnede beløpet kan inneholde gjeld som ikke er kredittkort- eller forbruksgjeld.
            Det er kun summen av rentebærende kredittkort- og/eller forbruksgjeld som er med i
            trekningen.
          </p>
          <p>
            Scoopr forbeholder seg retten til å endre «beløpet» dersom beregningsgrunnlaget fra
            Gjeldsregisteret inneholder gjeld som er ikke er definert som kredittkort- og/eller
            forbruksgjeld.
          </p>
          <p>
            Kostnadene for forbrukslån inkluderer gebyrer, men dersom antall terminer er 0/Null så
            inkluderes ikke lånet Rentebærende kredittkortgjeld gjøres om til et annuitetslån på 5
            år.
          </p>
          <p>
            Kostnadene beregnet for betjening av kredittkort- og/eller forbruksgjeld deltakerne har,
            summeres til en totalkostnad og er beløpet deltakeren deltar med i Juli-kampanjen
          </p>
          <br />
          <h4>Scoopr AS</h4>
          <h4>Scoopr Refinansiering AS</h4>
          <p>
            <a href="mailto:post@scoopr.no">post@scoopr.no</a>
          </p>
          <p>Karenslyst Allé 2</p>
          <p>0278 Oslo</p>
        </Box>
      </StaticPageLayout>
    </Page>
  );
}
